import * as Types from '../../actions/type'
const initialState = {
    loading: false,
    loaded: false,
    data: [],
    params: null,
    allData: [],
    restaurantData: []
}

const getIndex = (arr, arr2, arr3, params = {}) => {
    if (arr2.length > 0) {
      let startIndex = arr.findIndex(i => i.id === arr2[0].id) + 1
      let endIndex = arr.findIndex(i => i.id === arr2[arr2.length - 1].id) + 1
      let finalArr = [startIndex, endIndex]
      return (arr3 = finalArr)
    } else {
      let finalArr = [params.page, params.pages]
      return (arr3 = finalArr)
    }
}

export const mealsDetails = ( state=initialState, action) =>{
    switch (action.type){
        case Types.GET_RESORT_MEALS_DETAILS:
            return { ...state, loading: true };
        case Types.GET_RESORT_MEALS_DETAILS_SUCCESS: 
            let newData = { ...action.payload}
            newData.allData = action.payload.hasOwnProperty('meals')? [...action.payload.meals]: [];
            newData.sortIndex = action.payload.hasOwnProperty('meals')? getIndex(action.payload.meals, state.data, state.sortIndex, {...action.payload}):[];
                return { ...state, loading: false, loaded: true, payload: action.payload.hasOwnProperty('meals')? newData: {} }
        case Types.GET_RESORT_MEALS_DETAILS_FAILURE:
                return { ...state, loading: false, loaded: false, error: action.payload }
        case Types.GET_RESORT_RESTAURANTS_DATA:
                    return { ...state, restaurantData: action.payload.restaurants };        
        default: 
            return state
    }
}



